export const RECOGNIZABLE_EMOTIONS = [
  { name: 'joy', imageUrl: './assets/joy1.png' },
  { name: 'anger', imageUrl: './assets/anger1.png' },
  { name: 'sadness', imageUrl: './assets/sadness1.png' },
  { name: 'disgust', imageUrl: './assets/disgust2.png' },
  { name: 'fear', imageUrl: './assets/fear3.png' },
  { name: 'surprise', imageUrl: './assets/surprise1.png' }
];